import axios from 'axios';
import { Loading } from 'element-ui';
import Cookies from 'js-cookie';
import qs from 'qs'
import router from '../router/index';

var instance = axios.create({
    baseURL: ''
});
const ajax = {
    get: function (url, params = {}) {
        const loadingInstance = Loading.service({
            text: '拼命加载中',
            target: document.querySelector('.loadingtext'),
            background: 'rgba(0, 0, 0, 0.4)',
            spinner: 'el-icon-loading',
            lock: true
        });
        instance.defaults.headers.common['token'] = Cookies.get('doctortoken');
        return new Promise((resolve, reject) => {
            instance.get(url, {
                params: params
            })
                .then((response) => {
                    if (response.data.code === 0) {
                        loadingInstance.close();
                        resolve(response.data);
                    } else {
                        loadingInstance.close();
                        resolve(response.data);
                    }
                })
                // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                    console.log(error);
                    loadingInstance.close();
                    if (error.response.status === 798) {
                        this.$message.error('登录信息过期，请重新登录');
                        router.push({
                            path: '/login'
                        });
                    } else {
                        this.$message.error('网络状况不佳,请稍后重试');
                    }
                });
            loadingInstance.close();
        });
    },
    noloadingget: function (url, params = {}) {
        instance.defaults.headers.common['token'] = Cookies.get('doctortoken');
        return new Promise((resolve, reject) => {
            instance.get(url, {
                params: params
            })
                .then((response) => {
                    if (response.data.code === 0) {
                        resolve(response.data);
                    }
                })
                // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                    console.log(error);
                    if (error.response.status === 798) {
                        this.$message.error('登录信息过期，请重新登录');
                        router.push({
                            path: '/login'
                        });
                    }
                });
        });
    },
    post: function (url, data = {}, isformdata, vue) {
        if (vue) {
            vue.btnloading = true;
        }
        const loadingInstance = Loading.service({
            text: '拼命加载中',
            target: document.querySelector('.loadingtext'),
            background: 'rgba(0, 0, 0, 0.4)',
            spinner: 'el-icon-loading',
            lock: true
        });
        if (isformdata) {
            data = qs.stringify(data)
        }
        instance.defaults.headers.common['token'] = Cookies.get('doctortoken');
        return new Promise((resolve, reject) => {
            instance.post(url, data)
                .then((response) => {
                    if (vue) {
                        vue.btnloading = false;
                    }
                    if (response.data.code) {
                        loadingInstance.close();
                        resolve(response.data);
                    } else {
                        loadingInstance.close();
                        resolve(response.data);
                    }
                })
                // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                    console.log(error);
                    loadingInstance.close();
                    if (error.response.status === 798) {
                        this.$message.error('登录信息过期，请重新登录');
                        router.push({
                            path: '/login'
                        });
                    } else {
                        this.$message.error('网络状况不佳,请稍后重试');
                    }
                });
            loadingInstance.close();
        });
    },
};
export default ajax;





// WEBPACK FOOTER //
// ./src/utils/request.js